// import axios from "axios";

// // Set base URL
// axios.defaults.baseURL = process.env.REACT_APP_API_URL;
// axios.defaults.headers.post["Content-Type"] = "application/json";

// // Helper to check if JWT token is expired
// const isTokenExpired = (token: string): boolean => {
//   try {
//     const payload = JSON.parse(atob(token.split('.')[1]));
//     const exp = payload.exp;
//     if (!exp) return true;
//     const currentTime = Math.floor(Date.now() / 1000);
//     return currentTime > exp;
//   } catch (err) {
//     return true;
//   }
// };

// // Redirect to login and clear storage
// const redirectToLogin = () => {
//   localStorage.removeItem("authUser");
//     localStorage.removeItem("token");
//   setTimeout(() => {
//     alert("Your session has expired");
//     window.location.href = "/login";
//   }, 1000);
// };

// // Request interceptor to set Authorization header and check token validity
// axios.interceptors.request.use(
//   (config) => {
//     const authUser = localStorage.getItem("authUser");
//     const token = authUser ? JSON.parse(authUser)?.token : null;

//     if (token) {
//       if (isTokenExpired(token)) {
//         redirectToLogin();
//         return Promise.reject("Token expired");
//       }

//       if (config.headers) {
//         config.headers["Authorization"] = `Bearer ${token}`;
//       }
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Global response interceptor
// axios.interceptors.response.use(
//   (response) => response.data || response,
//   (error) => {
//     const status = error.response?.status;

//     if (status === 401) {
//       redirectToLogin();
//     }

//     const message =
//       status === 500 ? "Internal Server Error" :
//         status === 401 ? "Invalid credentials" :
//           status === 404 ? "Not Found" :
//             error.message || "Something went wrong";

//     return Promise.reject(message);
//   }
// );

// // Set token manually (after login)
// const setAuthorization = (token: string) => {
//   axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
// };

// // API Client Class
// class APIClient {
//   get = (url: string, params?: object) => axios.get(url, { params });

//   post = (url: string, data: any, customHeaders: object = {}) => {
//     const isFormData = data instanceof FormData;
//     const headers = isFormData
//       ? customHeaders
//       : { 'Content-Type': 'application/json', ...customHeaders };

//     return axios.post(url, data, { headers });
//   };

//   put = (url: string, data: object, customHeaders: object = {}) =>
//     axios.put(url, data, { headers: customHeaders });

//   patch = (url: string, data: object, customHeaders: object = {}) =>
//     axios.patch(url, data, { headers: customHeaders });

//   delete = (url: string) => axios.delete(url);
// }

// // Get logged-in user
// const getLoggedinUser = () => {
//   const user = localStorage.getItem("authUser");
//   return user ? JSON.parse(user) : null;
// };

// export const apiClient = new APIClient();
// export { setAuthorization, getLoggedinUser };
import axios from "axios";

// Set base URL
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp;
    if (!exp) return true;
    const currentTime = Math.floor(Date.now() / 1000);
    return currentTime > exp;
  } catch (err) {
    return true;
  }
};


axios.interceptors.request.use((config) => {
  const authUser = localStorage.getItem("authUser");
  const token = authUser ? JSON.parse(authUser)?.token : null;
  const checkTokenAndRedirect = () => {
  if (token && isTokenExpired(token)) {
    localStorage.clear();
    window.location.href = "/login";
    return true;
  }
  return false;
};
  if (token && config.headers && !isTokenExpired(token)) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  else if (token) {
  checkTokenAndRedirect();
}
  return config;


}, (error) => {
  return Promise.reject(error);
});

// Global response interceptor
axios.interceptors.response.use(
  response => response.data || response,
  error => {
    const status = error.response?.status;
    if (status === 401) {
      setTimeout(() => {
        alert("Your session has expired");
        return window.location.href = "/login";
      }, 2000)
    }
    const message =
      status === 500 ? "Internal Server Error" :
        status === 401 ? "Invalid credentials" :
          status === 404 ? "Not Found" :
            error.message || "Something went wrong";

    return Promise.reject(message);
  }
);

// Set token after login if needed
const setAuthorization = (token: string) => {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

// API Client Class
class APIClient {
  get = (url: string, params?: object) => axios.get(url, { params });

  post = (url: string, data: any, customHeaders: object = {}) => {
    const isFormData = data instanceof FormData;
    const headers = isFormData
      ? customHeaders
      : { 'Content-Type': 'application/json', ...customHeaders };

    return axios.post(url, data, { headers });
  };

  put = (url: string, data: object, customHeaders: object = {}) => axios.put(url, data, { headers: customHeaders });

  patch = (url: string, data: object, customHeaders: object = {}) => axios.patch(url, data, { headers: customHeaders });

  delete = (url: string) => axios.delete(url);
}

// Get logged-in user
const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export const apiClient = new APIClient();
export { setAuthorization, getLoggedinUser };
